import { Pipe, PipeTransform } from '@angular/core'
@Pipe({
  name: 'FilterPrograms',
})
export class FilterProgramsPipe implements PipeTransform {
  transform(items: any[], searchString: string): any[] {
    if (!items) {
      return []
    }
    if (!searchString || searchString === '') {
      return items
    }
    return items.filter(item => {
      const categories = item.categories.toString()
      const filter = `${item.title} ${item.keywords} ${categories}`
      return filter && filter.toLowerCase().includes(searchString.toLowerCase())
    })
  }
}
